import React from "react";
import Header from "../components/Header";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import Aboutbanner from "../Page-section/About/Aboutbanner";
import Aboutsection from "../Page-section/About/Aboutsection";
// import Ourteam from '../Page-section/About/Ourteam';
import WhyChoose from "../Page-section/About/Whychoose";
import Client from "../components/Client";
import { Helmet } from "react-helmet";
// import PortfolioSlider from "../Page-section/Home/PortfolioSlider";

function About() {
  return (
    <div>
      <Helmet>
        <title>About Empower Web – Best Web Development Company in Noida</title>
        <meta
          name="description"
          content="Looking for a web development company near me? Discover Empower Web – experts in SEO, web design & digital marketing. Trusted by 500+ clients. Visit now!"
        />
        <meta
          name="keywords"
          content="best website development company, web design and development company, best website designing company in Noida"
        />
        <link rel="canonical" href="https://empowerweb.in/about" />
        <meta
          property="og:title"
          content="About Us | Digital Marketing Company"
        />
        <meta
          property="og:description"
          content="We provide SEO, web development and digital marketing services."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://empowerweb.in/about" />

        <meta name="robots" content="index, follow" />
      </Helmet>
      <Header />
      <Navbar />
      <Aboutbanner />
      <Aboutsection />
      {/* <PortfolioSlider /> */}

      {/* <Ourteam /> */}
      <Client />
      <WhyChoose />
      <Footer />
    </div>
  );
}

export default About;
